<form #compteForm="ngForm" name="contrat-compte" autocomplete="off">
    <mat-card *ngIf="contenuCharge">
        <mat-card-title>
            <span>{{ 'admin.frais.fournisseurs.compte.title' | translate }}</span>
        </mat-card-title>
        <mat-card-content>
            <div class="row">
                    <!-- Champ pour le numéro de carte en mode création et type CARTE -->
                    <custom-input *ngIf="compte.typeCarte == TypeCarte.AFFAIRE && isCreation"
                                [(ngModel)]="compte.idCarte"
                                  name="idCarte"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.compte.numero"
                                  [required]="true"
                                  [disabled]="!isCreation"
                                  maxLength="20"
                                  pattern="[0-9]{16}"
                                  placeholder="XXXX-XXXX-XXXX-XXXX"
                                  ngDefaultControl>
                    </custom-input>

                    <!-- Champ pour le numéro de carte de type différent de CARTE -->
                    <custom-input *ngIf="compte.typeCarte !== TypeCarte.AFFAIRE"
                                  [(ngModel)]="compte.idCarte"
                                  name="idCarte"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.compte.numero"
                                  [required]="true"
                                  [disabled]="!isCreation"
                                  ngDefaultControl>
                    </custom-input>
                    
                    <!-- Champ pour le numéro de carte en mode édition et type CARTE (masqué) -->
                    <custom-input *ngIf="compte.typeCarte === TypeCarte.AFFAIRE && !isCreation"
                                  [(ngModel)]="compte.numCarteClair"
                                  name="idCarte"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.compte.numero"
                                  [required]="true"
                                  [disabled]="true"
                                  ngDefaultControl>
                    </custom-input>

                    <custom-input [(ngModel)]="compte.actif"
                                  [(customModel)]="compte.actif"
                                  name="isActif"
                                  customType="checkbox"
                                  libelle="admin.frais.fournisseurs.compte.actif"
                                  ngDefaultControl>
                    </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="compte.libelle"
                              name="libelle"
                              customType="input"
                              libelle="admin.frais.fournisseurs.compte.libelle"
                              maxlength="50"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input ngDefaultControl
                              name="collaborateur"
                              libelle="admin.frais.fournisseurs.compte.collaborateur"
                              customType="autocomplete"
                              autocompleteType="user"
                              optionDisplay="nomPrenomMatricule"
                              [autocompleteFilter]="{isHabilitation: true}"
                              [idName]="'idUser'"
                              [(ngModel)]="compte.user"
                              [required]="true">
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="compte.dateFin"
                              [(customModel)]="compte.dateFin"
                              name="dateFin"
                              customType="date"
                              libelle="admin.frais.fournisseurs.compte.validite"
                              [required]="true"
                              ngDefaultControl>
                </custom-input>

                <custom-input [(ngModel)]="compte.referenceImport"
                              name="referenceImport"
                              customType="input"
                              libelle="admin.frais.fournisseurs.compte.identifiantImport"
                              maxlength="2000"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="compte.typeDebit"
                              name="typeDebit"
                              customType="select"
                              libelle="admin.frais.fournisseurs.compte.debitSur"
                              [required]="true"
                              [selectOptions]="listeTypesDebit"
                              [disabled]="!isCreation"
                              optionValue="type"
                              optionDisplay="libelle"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="compte.compteTiers"
                              name="compteTiers"
                              customType="select"
                              libelle="admin.frais.fournisseurs.compte.compteTiers"
                              [selectOptions]="listeCompteTiers"
                              [disabled]="compte.typeDebit === TypeDebit.COLLAB || !isCreation"
                              optionValue="numero"
                              optionDisplay="libelle"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="compte.compteBanque"
                              name="compteBanque"
                              customType="select"
                              libelle="admin.frais.fournisseurs.compte.compteBanque"
                              [selectOptions]="listeCompteBancaire"
                              [disabled]="compte.typeDebit === TypeDebit.COLLAB || !isCreation"
                              optionValue="numero"
                              optionDisplay="libelle"
                              ngDefaultControl>
                </custom-input>
            </div>
        </mat-card-content>
    </mat-card>
</form>
<please-wait class="content" *ngIf="!contenuCharge"></please-wait>

